import React, { useState } from 'react';
import 'react-json-view-lite/dist/index.css';
import { FlexyTabs } from '@europrocurement/flexy-components';
import PanelColors from '../components/PanelColor/PanelColors';
import PanelEnvironment, {
    type PanelEnvironmentType,
} from '../components/PanelEnvironment/PanelEnvironment';
import PanelFormulaires from '../components/PanelFormulaires/PanelFormulaires';
import PanelIcons from '../components/PanelIcons/PanelIcons';
import PanelKeycloak from '../components/PanelKeycloak/PanelKeycloak';
import PanelTests from '../components/PanelTests/PanelTests';
import PanelTypography from '../components/PanelTypography/PanelTypography';

import PanelRecap from '../components/PanelRecap/PanelRecap';

/**
 * Props pour le composant Debug
 */
export type DebugType = {
    /** Configuration de l'environnement à afficher dans le panneau correspondant */
    panelEnvironnement: PanelEnvironmentType;
};

/**
 * Onglets disponibles dans le panneau de debug
 */
type DebugTab =
    | 'env'
    | 'icons'
    | 'typo'
    | 'palette'
    | 'keycloak'
    | 'formulaires'
    | 'recap'
    | 'tests';

/**
 * Composant d'outils de développement permettant de visualiser différents aspects
 * du système : environnement, iconographie, typographie, couleurs, etc.
 *
 * Ce composant utilise FlexyTabs avec un état local pour gérer les onglets sans
 * modifier l'URL, ce qui le rend adapté à une utilisation dans des modales.
 */
export const Debug: React.FunctionComponent<DebugType> = function ({ panelEnvironnement }) {
    const [activeTabName, setActiveTabName] = useState<DebugTab>('env');

    /**
     * Définition de la structure des onglets du panneau de debug
     */
    const debugTabs = [
        {
            tabName: 'env',
            tabTitle: 'Environnement',
            tabPanel: <PanelEnvironment {...panelEnvironnement} />,
        },
        {
            tabName: 'icons',
            tabTitle: 'Iconographies',
            tabPanel: <PanelIcons />,
        },
        {
            tabName: 'typo',
            tabTitle: 'Typography',
            tabPanel: <PanelTypography />,
        },
        {
            tabName: 'palette',
            tabTitle: 'Palette',
            tabPanel: <PanelColors />,
        },
        {
            tabName: 'keycloak',
            tabTitle: 'Keycloak',
            tabPanel: <PanelKeycloak />,
        },
        {
            tabName: 'formulaires',
            tabTitle: 'Tests formulaires',
            tabPanel: <PanelFormulaires />,
        },
        {
            tabName: 'recap',
            tabTitle: 'Tests Recap',
            tabPanel: <PanelRecap />,
        },
        {
            tabName: 'tests',
            tabTitle: 'Tests',
            tabPanel: <PanelTests />,
        },
    ];

    return (
        <FlexyTabs
            status={undefined}
            sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '15px' }}
            useLocalState
            activeTabName={activeTabName}
            onTabChange={(tabName) => setActiveTabName(tabName as DebugTab)}
            defaultTab="env"
            tabs={debugTabs}
        />
    );
};
